import { useState } from 'react';
import { List } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { TableOfContents, type TocItem } from '../TableOfContents';

interface MobileTocSheetProps {
  items: TocItem[];
  activeSection: string;
}

export function MobileTocSheet({ items, activeSection }: MobileTocSheetProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('help');

  return (
    <>
      {/* Floating button (visible below lg breakpoint) */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-30 lg:hidden flex items-center gap-2 px-4 py-2.5 bg-brand-gradient text-white text-sm font-medium rounded-full shadow-lg hover:shadow-xl transition-shadow"
      >
        <List className="w-4 h-4" />
        {t('mobileContents')}
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 p-0">
          <div className="px-5 py-4 border-b border-slate-100">
            <p className="text-sm font-bold">{t('tocTitle')}</p>
          </div>
          <div className="px-3 py-4 overflow-y-auto h-[calc(100%-57px)]">
            <TableOfContents
              items={items}
              activeSection={activeSection}
              onSelect={() => setOpen(false)}
            />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
